<form (ngSubmit)="submit()" #form="ngForm">
  <nb-card>
    <nb-card-header>
      <span class="title">{{ 'Send an email' | translate }}</span>
    </nb-card-header>

    <nb-card-body>
      <!-- RECIPIENTS (multi-select chips + free text) -->
      <div class="form-group row">
        <label class="label col-3" for="recipient">{{ 'Recipient' | translate }}</label>
        <div class="col-9">
          <nb-form-field>
            <nb-tag-list (tagRemove)="onTagRemove($event)">
              @for (recipient of recipients; track recipient) {
                <nb-tag [text]="recipient" removable></nb-tag>
              }
              <input
                #recipientInput
                type="text"
                id="recipient"
                nbTagInput
                fullWidth
                [status]="recipientError ? 'danger' : 'basic'"
                [(ngModel)]="inputValue"
                name="recipientInput"
                (ngModelChange)="onInputChange()"
                (keydown.enter)="onEnter($event)"
                [mention]="mentionUsers"
                [mentionConfig]="mentionConfig"
                (itemSelected)="onMentionSelected($event)"
                placeholder="name@example.com"
                autocomplete="off"
              >
            </nb-tag-list>
          </nb-form-field>
          @if (recipientError) {
            <div class="error-message">{{ recipientError | translate }}</div>
          }
        </div>
      </div>

      <!-- CONTEXT -->
      <p class="context-line">
        {{ 'Investment concerned' | translate }} : {{ investmentLabel || '-' }}
      </p>
      <p class="context-line">
        {{ 'Site concerned' | translate }} : {{ siteName || '-' }}
      </p>

      <!-- MESSAGE -->
      <div class="form-group row">
        <label class="label col-3" for="message">{{ 'Message' | translate }}</label>
        <div class="col-9">
          <textarea
            nbInput
            fullWidth
            id="message"
            name="message"
            rows="5"
            [(ngModel)]="message"
            placeholder="{{ 'Enter your message' | translate }}"
          ></textarea>
        </div>
      </div>
    </nb-card-body>

    <nb-card-footer class="text-right">
      <button nbButton type="button" class="cancel" (click)="close()">
        {{ 'Cancel' | translate }}
      </button>
      <button nbButton type="submit" [disabled]="!canSubmit">
        {{ 'OK' | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
